import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { Button, FieldTextInput, OutsideClickHandler, TravelStyleField } from '../../../../components';
import { injectIntl, intlShape } from '../../../../util/reactIntl';
import css from './CustomListingSearchForm.module.css';
import { TRAVEL_TYPES } from '../../../../util/types';
import axios from 'axios';
import IconCollection from '../../../../components/IconCollection/IconCollection';
import { CORRDINATES } from '../SectionMap/SectionMap';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { formatLocationString } from '../../../../util/data';

const identity = v => v;

const LocationSearchField = ({ desktopInputRootClass, intl, isMobile, inputRef, onLocationChange, formApi }) => {
  const [destinations, setDestinations] = useState([]);
  const mapboxToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
  const [countryInput, setCountryInput] = useState('');
  const [countryInputFocused, setCountryInputFocused] = useState(false);
  const countryDropdownRef = useRef(null);
  const showPredictions = countryInputFocused;
  const [predictions, setPredictions] = useState([]);

  const { pageId } = useParams();
  const limitSearch = pageId && CORRDINATES[pageId] ? CORRDINATES[pageId]["limitSearch"] : null;

  function getUniqueByRegionName(features) {
    const seenRegions = new Set();
    const uniqueFeatures = [];

    for (const feature of features) {
      const context = feature?.properties?.context;
      const regionName = context?.region?.name;
      const countryName = context?.country?.name;

      if (regionName && !seenRegions.has(regionName)) {
        seenRegions.add(regionName);
        uniqueFeatures.push(feature);
      }

      else if (!regionName && countryName) {
        uniqueFeatures.push(feature);
      }
    }

    return uniqueFeatures;
  }

  const fetchPredictions = async query => {
    try {
      // const Oldurl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${mapboxToken}&types=country,region${Array.isArray(limitSearch) && limitSearch.length ? "&country=" + limitSearch.join(",") : ""}`
      const urlV6 = `https://api.mapbox.com/search/geocode/v6/forward?q=${query}&access_token=${mapboxToken}`

      const response = await axios.get(
        urlV6, {
        params: {
          types: "country,region,place"
        }
      }
      );

      // const predictions = response.data.features.filter(prediction => !destinations.includes(prediction));
      const predictions = response.data.features.filter(({ properties: { full_address } }) => {
        return !destinations.includes(formatLocationString(full_address, '_'));
      });

      const uniquePredictions = getUniqueByRegionName(predictions);
      setPredictions(uniquePredictions);
    } catch (error) {
      console.error('Error fetching predictions:', error);
    }
  };

  useEffect(() => {
    if (countryInput) {
      fetchPredictions(countryInput);
    } else {
      setPredictions([]);
    }
  }, [countryInput, destinations]);

  const handleInputChange = e => {
    formApi.change('location', e.target.value);
    setCountryInput(e.target.value);
  };
  const handlePredictionClick = prediction => {
    const { properties } = prediction || {};
    const { feature_type, full_address, context } = properties || {};
    const { country, region } = context || {};

    setCountryInput(full_address);
    formApi.change('location', prediction.properties?.context?.region?.name ? `${prediction.properties.context.region.name}, ${prediction.properties.context.country.name}` : prediction.properties.context.country.name);

    // if selection is country
    if (country?.name) {
      formApi.change('country', country.name);
    }

    // if selection is region
    if (region?.name) {
      formApi.change('country', country.name);
      formApi.change('region', `${country.name}_${region.name}`);
    }

    setPredictions([]);
    setCountryInputFocused(false);
  };

  return (
    <OutsideClickHandler className={css.locationSearchForm} onOutsideClick={() => setCountryInputFocused(false)}>
      <IconCollection icon="worldIcon" />
      <FieldTextInput
        id="location"
        name="location"
        type="text"
        autoComplete={'off'}
        className={css.mobileInputRoot}
        placeholder={'Destination (country)'}
        onFocus={() => setCountryInputFocused(true)}
        onChange={handleInputChange}
        value={countryInput}
        closeonblur={'true'}
      />

      {predictions.length > 0 && showPredictions && (
        <ul className={css.dropdown} ref={countryDropdownRef}>
          {predictions.map((prediction, index) => (
            <li className={css.predictionItem} key={`${prediction.id}-${index}`} onClick={() => handlePredictionClick(prediction)}>
              {prediction.properties?.context?.region?.name ? `${prediction.properties.context.region.name}, ` : ''}{prediction.properties?.context?.country?.name}
            </li>
          ))}
        </ul>
      )}
    </OutsideClickHandler>
  );
};

const CustomListingSearchForm = ({ intl, onSubmit }) => {
  return (
    <FinalForm
      onSubmit={onSubmit}
      render={({ handleSubmit, form }) => (
        <form className={css.orderForm} onSubmit={handleSubmit}>
          <div>
            <LocationSearchField formApi={form} onLocationChange={() => { }} />
          </div>
          <TravelStyleField selectedTravelStyles={TRAVEL_TYPES} />
          <Button type="submit" className={css.searchButton}>Find Travel Experts</Button>
        </form>
      )}
    />
  );
};

CustomListingSearchForm.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default injectIntl(CustomListingSearchForm);
